'use client'

import { SessionProvider } from 'next-auth/react'
import { type FC, type PropsWithChildren } from 'react'

/**
 * Contains all the common providers for the app.
 * If you have to add a new global provider, add it here unless there's a specific reason not to.
 * In that case, please document your reasoning.
 */
const Providers: FC<PropsWithChildren> = ({ children }) => (
  <SessionProvider>
    {children}
  </SessionProvider>
)

export default Providers
